"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEntries200ResponseToJSON = exports.GetEntries200ResponseFromJSONTyped = exports.GetEntries200ResponseFromJSON = exports.instanceOfGetEntries200Response = void 0;
var runtime_1 = require("../runtime");
var GiveawayParticipantEntry_1 = require("./GiveawayParticipantEntry");
/**
 * Check if a given object implements the GetEntries200Response interface.
 */
function instanceOfGetEntries200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetEntries200Response = instanceOfGetEntries200Response;
function GetEntries200ResponseFromJSON(json) {
    return GetEntries200ResponseFromJSONTyped(json, false);
}
exports.GetEntries200ResponseFromJSON = GetEntries200ResponseFromJSON;
function GetEntries200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (json['data'].map(GiveawayParticipantEntry_1.GiveawayParticipantEntryFromJSON)),
    };
}
exports.GetEntries200ResponseFromJSONTyped = GetEntries200ResponseFromJSONTyped;
function GetEntries200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data === undefined ? undefined : (value.data.map(GiveawayParticipantEntry_1.GiveawayParticipantEntryToJSON)),
    };
}
exports.GetEntries200ResponseToJSON = GetEntries200ResponseToJSON;
